<template>
  <div class="audit-info-container">
    <InfoContainer
      :infoTitle="InfoContainerConfig['infoTitle']"
      :contentConfig="InfoContainerConfig['infoContent']"
    >
      <template :slot="InfoContainerConfig['infoContent'][0]['prop']">
        <!-- 查询表单配置后回显表单 -->
        <!-- 表单数据查询接口 -->
        <avue-form
          ref="basicInfo"
          v-model="formData"
          :option="avueFormConfig"
        >
        </avue-form>
      </template>
    </InfoContainer>
  </div>
</template>
<script>
import InfoContainer from "@/components/infoContainer/infoContainer";
import workFlow from '@/mixins/workFlow'
import {formConfig} from './form.js'
export default {
  name: 'AuditInfo',
  mixins: [workFlow],
  data() {
    return {
      formData: {},
      avueFormConfig: {
        submitBtn: false,
        emptyBtn: false
      },
      InfoContainerConfig: {
        infoTitle: '审批信息',
        infoContent: [{
          title: '',
          prop: 'basicInfo'
        }]
      }
    }
  },
  props: {
    /**
     * @param {String} processId 流程ID
     */
    processId: {
      type: String,
      default: ''
    },

    /**
     * @param {String} processId 流程ID
     */
    formDetailData: {
      type: Object,
      default: () => {
        return {}
      }
    },

    /**
     * @param {String} status 流程状态todo/done
     */
    status: {
      type: String,
      default: 'done'
    },
    /**
     * @param {Boolean} isEditable 是否可编辑
     */
    isEditable: {
      type: Boolean,
      default: false
    }
  },
  components: {
    InfoContainer
  },
  watch: {
    formDetailData: {
      handler(val) {
        if(val.allAppForm) this.dealForm(val)
      },
      immediate: true,
      deep: true
    }
  },
  computed: {
    commentDetail() {
      return this.$refs.basicInfo?this.$refs.basicInfo.propOption:{}
    }
  },
  mounted() {
  },
  methods: {
    dealForm(val) {
      let self = this
      let config = JSON.parse(val.allAppForm)
      if(this.status == 'done') {
        config.column.forEach(item => {
          item.disabled = true
        })
      }
      
      if(val.taskForm){
        // 处理绑定数据 提取val中的数据
        config.column.map(item => {
          let filterObj = val.taskForm.filter(obj => {
            return obj.id === item.prop
          })
          if(filterObj&& filterObj.length> 0){
            item.display = filterObj[0].readable?true: false
            item.disabled = filterObj[0].writable?false: true
            item.required = filterObj[0].required?true: false
            // self.formData[item.prop] = filterObj[0].value
            self.$set(self.formData, item.prop, filterObj[0].value)
            item.value = filterObj[0].value
          }else{
            item.display = false,
            item.disabled = true,
            item.required = false
          }
        })
        // 从val.taskForm中以id为key提取value数据，重组成formData
        val.taskForm.map(item => {
          self.$set(self.formData, item.id, item.value)
        })
      } else {
        // 无taskForm数据，直接提取process中variables数据，并设置表单为只读
        config.column.map(item => {
          self.$set(self.formData, item.prop, val.variables[item.prop])
          item.disabled = !self.isEditable
        })
      }
      this.avueFormConfig = config

      // 设置配置的按钮显示
      this.avueFormConfig.submitBtn = false
      this.avueFormConfig.emptyBtn = false
    },

    validData() {
      let finish = true
      let submitData = this.dealAuditForm(this.formData, this.commentDetail)
      // this.avueFormConfig.column.map(item => {
      //   if(!item.disabled && item.required && submitData[item.prop] == '') {
      //     this.$message.error('请补全' + item.label +'审批意见')
      //     this.$el.querySelector('#infoHead').scrollIntoView()
      //     finish = false
      //   }

      //   // 若组件为多人审批意见
      //   if(item.component == 'wf-users-opinion'){
      //     // let initContent = item.
      //     let validData = JSON.parse(submitData[item.prop])
      //     validData.map(item => {
      //       if(item.opinionContent.trim() == '') {
      //         this.$message.error('请补全审批信息')
      //         this.$el.querySelector('#infoHead').scrollIntoView()
      //         finish = false
      //       }
      //     })
      //   }
      // })

      for( let item of this.avueFormConfig.column) {
        if(!item.disabled && item.required && submitData[item.prop] == '') {
          this.$message.error('请补全' + item.label +'审批意见')
          this.$el.querySelector('#infoHead').scrollIntoView()
          finish = false
          return
        }
        // 若组件为多人审批意见
        if(item.component == 'wf-users-opinion'){
          let validData = JSON.parse(submitData[item.prop])
          for(let op of validData) {
            if(op.opinionContent.trim() == '') {
              this.$message.error('请补全审批信息')
              this.$el.querySelector('#infoHead').scrollIntoView()
              finish = false
              return
            }
          }
        }
      }
      return finish
    },

    setFormData(prop, value) {
      this.$set(this.formData, prop, value)
    }

  }
}
</script>
<style lang="scss" scoped>
.audit-info-container{
  margin-top: 20px;
}
</style>